import type { GetStaticProps, NextPage } from "next";
import Layout from "../components/Layout";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { history } from "../routes/namespaces";
import HistoryHeader from "../components/History/HistoryHeader/HistoryHeader";
import Timeline from "../components/History/Timeline/Timeline";
import CareerOffer from "components/History/CareerOffer/CareerOffer";

const History: NextPage = () => {
  const { t } = useTranslation(["history", "navigation"]);

  return (
    <Layout bgPrimary title={t("history", { ns: "navigation" })}>
      <HistoryHeader />
      <Timeline />
      <CareerOffer />
    </Layout>
  );
};

export default History;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(
        locale || "cs",
        history
      )),
    },
  };
};
